var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":_vm.onClick}},[(_vm.isActive)?_c('activity-unread-icon'):_c('activity-icon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }